export enum UserState {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export enum StateTranslate {
  ACTIVE = "Activo",
  INACTIVE = "Inactivo",
}

export enum Times {
  NO_TIME = "--:--:--",
  CERO = "0 hs - 0 min",
}

export enum Roles {
  HELPER = "Helper",
  HELPER_SSR = "Helper SSr",
  NO_HELPER = "No Helper",
}

export interface ConnectionCreate {
  userId: string;
}

export interface UserInCompany {
  idChecking: string;
  email: string;
  companyName: string;
}

export interface ControlPanelUser {
  userInCompany?: UserInCompany; // user in company  | null
  state: UserState;
}

export interface Checking {
  id: string;
  company_name: string;
  start_time: Date | string;
  end_time: Date | string;
  duration?: number;
}

export interface ConnectionUser {
  user_id: string;
  state: UserState;
  start_time: Date | string;
  end_time: Date | string;
  checking: Checking[];
}

export interface ConnectionUserUpdate {
  userId: string;
  state?: UserState;
  checking?: CheckingUp;
}

export type ConnectionUserUp = Omit<ConnectionUser, "state">;

export interface ControlUser {
  start_time: Date | string;
  end_time: Date | string;
  name: string;
  roles: string [];
  state: UserState;
  checking?: Checking[];
  email: string;
}

export interface ApiAnswer {
  success: boolean;
}

export interface CheckingUp {
  id: string;
  companyName: string;
}
